import React from 'react'
import StoreProfile from './StoreProfile';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';

function StoreProfileWrap() {
    const { userData } = CheckUserProvider();

    return (
        <>
            <div className="StoreProfileWrap">
                {userData && <StoreProfile />}
            </div>
        </>
    )
}

export default StoreProfileWrap
